<template lang="pug">
    .filter(v-if="type === 'SingleInput'")
        .occupy-space.single-input
            slot(name="occupy-space" v-bind:value="singleInputValue")
                nobr {{ singleInputValue }}
        .input
            el-input.single-input(
                :clearable="true"
                v-model="SingleInput"
                :placeholder="placeholder"
                size="mini"
            )
    .filter(v-else-if="type === 'FromTo' || type === 'NumberFromTo'" :class="{ matchable }")
        .occupy-space.from-to
            slot(name="occupy-space" v-bind:from="fromValue" v-bind:to="toValue")
                div
                    nobr {{ fromValue }}
                div
                    nobr {{ toValue }}
            el-checkbox(:value="match === false" @change="match = !match")
                template(v-if="placeholder.from && placeholder.to") {{ placeholder.from }} / {{ placeholder.to }}
                template(v-else) {{ $t('from') }} / {{ $t('to') }}
        .input
            template(v-if="matchable === false || match === false")
                el-input.from(
                    :clearable="true"
                    v-model="From"
                    :type="type === 'FromTo' ? 'text' : 'number'"
                    :max="type === 'NumberFromTo' ? To : ''"
                    :placeholder="placeholder.from"
                    size="mini"
                )
                .to-flex
                    template(v-if="matchable === true && match === false")
                        el-checkbox(:value="match === false" @change="handleMatchCheckbox")
                    el-input.to(
                        :clearable="true"
                        v-model="To"
                        :type="type === 'FromTo' ? 'text' : 'number'"
                        :min="type === 'NumberFromTo' ? From : ''"
                        :placeholder="placeholder.to"
                        size="mini"
                    )
            template(v-else)
                el-input.single-input(
                    :clearable="true"
                    v-model="SingleInput"
                    :type="type === 'NumberFromTo' ? 'number' : 'text'"
                    :placeholder="placeholder.match"
                    size="mini"
                )
                el-checkbox(:value="match === false" @change="handleMatchCheckbox")
                    template(v-if="placeholder.from && placeholder.to") {{ placeholder.from }} / {{ placeholder.to }}
                    template(v-else) {{ $t('from') }} / {{ $t('to') }}
    //- .filter(v-else-if="type === 'FromTo'" :class="{ matchable }")
    //-     .occupy-space.from-to
    //-         div
    //-             nobr {{ fromValue }}
    //-         div
    //-             nobr {{ toValue }}
    //-         el-checkbox(:value="match === false" @change="match = !match")
    //-             template(v-if="placeholder.from && placeholder.to") {{ placeholder.from }} / {{ placeholder.to }}
    //-             template(v-else) {{ $t('from') }} / {{ $t('to') }}
    //-     .input
    //-         template(v-if="matchable === false || match === false")
    //-             el-input.from(
    //-                 :clearable="true"
    //-                 v-model="From"
    //-                 :placeholder="placeholder.from"
    //-                 size="mini"
    //-             )
    //-             .to-flex
    //-                 template(v-if="matchable === true && match === false")
    //-                     el-checkbox(:value="match === false" @change="handleMatchCheckbox")
    //-                 el-input.to(
    //-                     :clearable="true"
    //-                     v-model="To"
    //-                     :placeholder="placeholder.to"
    //-                     size="mini"
    //-                 )
    //-         template(v-else)
    //-             el-input.single-input(
    //-                 :clearable="true"
    //-                 v-model="SingleInput"
    //-                 :placeholder="placeholder.match"
    //-                 size="mini"
    //-             )
    //-             el-checkbox(:value="match === false" @change="handleMatchCheckbox")
    //-                 template(v-if="placeholder.from && placeholder.to") {{ placeholder.from }} / {{ placeholder.to }}
    //-                 template(v-else) {{ $t('from') }} / {{ $t('to') }}
    //- .filter(v-else-if="type === 'NumberFromTo'")
    //-     .occupy-space.number-from-to
    //-         div
    //-             nobr {{ fromValue }}
    //-         div
    //-             nobr {{ toValue }}
    //-     .input
    //-         el-input.from(
    //-             type="number"
    //-             :clearable="true"
    //-             v-model="From"
    //-             :max="To"
    //-             :placeholder="placeholder.from"
    //-             size="mini"
    //-         )
    //-         el-input.to(
    //-             type="number"
    //-             :clearable="true"
    //-             v-model="To"
    //-             :min="From"
    //-             :placeholder="placeholder.to"
    //-             size="mini"
    //-         )
    .filter(v-else-if="type === 'DateFromTo'")
        .occupy-space.date-from-to
            slot(name="occupy-space" v-bind:from="fromValue" v-bind:to="toValue")
                div
                    nobr {{ fromValue }}
                div
                    nobr {{ toValue }}
        .input
            el-date-picker(
                v-model="DateRange"
                :class="{ filled: DateRange[0] || DateRange[1] }"
                type="daterange"
                range-separator=""
                size="mini"
                :format="$t('yyyy-MM-dd')"
                prefix-icon="far el-icon-fa-calendar-alt"
                :start-placeholder="placeholder.from"
                :end-placeholder="placeholder.to"
                :unlink-panels="true"
                :picker-options="{firstDayOfWeek:1}"
            )
            // el-input.from(type="number" :clearable="true" v-model="From" :max="To" :placeholder="placeholder.from")
            // el-input.to(type="number" :clearable="true" v-model="To" :min="From" :placeholder="placeholder.to")
    .filter(v-else-if="type === 'DateTimeFromTo'")
        .occupy-space.date-from-to
            slot(name="occupy-space" v-bind:from="fromValue" v-bind:to="toValue")
                div
                    nobr {{ fromValue }}
                div
                    nobr {{ toValue }}
        .input
            el-date-picker(
                v-model="DateRange"
                :class="{ filled: DateRange[0] || DateRange[1] }"
                type="datetimerange"
                range-separator=""
                size="mini"
                :format="$t('yyyy-MM-dd') + ' HH:mm'"
                prefix-icon="far el-icon-fa-calendar-alt"
                :start-placeholder="placeholder.from"
                :end-placeholder="placeholder.to"
                :unlink-panels="true"
                :picker-options="{firstDayOfWeek:1}"
            )
            // el-input.from(type="number" :clearable="true" v-model="From" :max="To" :placeholder="placeholder.from")
            // el-input.to(type="number" :clearable="true" v-model="To" :min="From" :placeholder="placeholder.to")
    .filter(v-else-if="type === 'Select'")
        // :popper-append-to-body="false"
        .occupy-space.select
            slot(name="occupy-space" v-bind:option="activeOption")
                nobr(v-if="activeOption") {{ activeOption.label }}
                .occupy-select-input-space(v-if="activeOption && options && options.length > 10")
        .input
            el-select(
                clearable
                :filterable="isSearchableSelect"
                v-model="Select"
                :placeholder="placeholder"
                name="label"
                size="mini"
            )
                slot(name="options-template" v-bind:options="options")
                    el-option(
                        v-for="(item, index) in options"
                        :key="item.value || item.key"
                        :label="item.label"
                        :value="item.value || item.key"
                    )
                        slot(name="option-template" v-bind:item="item")
    .filter(v-else-if="type === 'MultiSelect'")
        // :popper-append-to-body="false"
        .occupy-space.multi-select
            slot(name="occupy-space" v-bind:options="activeOptions")
                div(v-for="option in activeOptions")
                    nobr {{ option.label }}
                .occupy-select-input-space(v-if="activeOptions.length && options && options.length > 10")
        .input
            el-select(
                multiple
                clearable
                :filterable="isSearchableSelect"
                v-model="multiSelect"
                :placeholder="placeholder"
                name="label"
                size="mini"
            )
                slot(name="options-template" v-bind:options="options")
                    el-option(
                        v-for="(item, index) in options"
                        :key="item.value || item.key || item.label"
                        :label="item.label"
                        :value="item.value || item.key || item.label"
                    )
                        slot(name="option-template" v-bind:item="item")
    .filter(v-else-if="type === 'TreeMultiSelect'")
        .occupy-space.multi-select
            slot(name="occupy-space" v-bind:options="activeTreeOptions")
                div(v-for="option in activeTreeOptions" :key="option.value")
                    nobr {{ getTreeBreadcrumb(option) }}
                .occupy-select-input-space(v-if="activeTreeOptions.length && options && options.length > 10")
        .input
            Treeselect(
                v-model="treeMultiSelect"
                :multiple="true"
                :options="treeOptions"
                :default-expand-level="Infinity"
                :close-on-select="false"
                :open-on-focus="true"
                :searchable="true"
                :normalizer="node => ({ label: node.label, ...node })"
                :flat="false"
                :value-consists-of="'LEAF_PRIORITY'"
                :append-to-body="true"
                placeholder=""
            )
                div(
                    slot="value-label"
                    slot-scope="{ node }"
                ) {{ getTreeBreadcrumb(node.raw) }}
    .filter(v-else)
        | {{ type }}
</template>

<i18n>
{
  "de": {
    "from": "von",
    "to": "bis"
  }
}
</i18n>

<script>
import _ from 'lodash';
import { format } from 'date-fns';
import Treeselect from '@riophae/vue-treeselect';
import NestedSet from '@/nested-set-lib';

export default {
    name: 'PaginationFilter',
    components: {
        Treeselect,
    },
    props: {
        name: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: false
        },
        // handleInput: {
        //     type: Function,
        //     default: () => {}
        // },
        values: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            singleInputValue: '',
            fromValue: '',
            toValue: '',
            match: false,
        };
        //     let From, To, DateRange
        //     if (this.type === 'DateFromTo') {
        //         const from = _.get(this.values, `${this.name}.from`, false)
        //         const start = from ? new Date(from * 1000) : ''

        //         const to = _.get(this.values, `${this.name}.to`, false)
        //         const end = to ? new Date(to * 1000) : ''

        //         DateRange = [start, end]
        //     } else {
        //         From = _.get(this.values, `${this.name}.from`, '')
        //         To = _.get(this.values, `${this.name}.to`, '')
        //     }

        //     return {
        //         SingleInput: _.get(this.values, `${this.name}.like`, ''),
        //         From,
        //         To,
        //         DateRange,
        //         Select: _.get(this.values, `${this.name}.match`, ''),
        //     };
    },
    // watch: {
    //     SingleInput(value) {
    //         const filterObject = {
    //             key: this.name,
    //             match: '',
    //             like: value,
    //             from: '',
    //             to: '',
    //             in: [],
    //         }

    //         this.handleInput(this.name, filterObject, ! _.isEmpty(value))
    //     },
    //     From(value) {
    //         const filterObject = {
    //             key: this.name,
    //             match: '',
    //             like: '',
    //             from: value,
    //             to: this.To,
    //             in: [],
    //         }

    //         this.handleInput(this.name, filterObject, ! _.isEmpty(value))
    //     },
    //     To(value) {
    //         const filterObject = {
    //             key: this.name,
    //             match: '',
    //             like: '',
    //             from: this.From,
    //             to: value,
    //             in: [],
    //         }

    //         this.handleInput(this.name, filterObject, ! _.isEmpty(value))
    //     },
    //     DateRange(value) {
    //         const start = _.get(value, 0, false)
    //         const from = start ? start.getTime() / 1000 : ''

    //         const end = _.get(value, 1, false)
    //         const to = end ? end.getTime() / 1000 : ''

    //         const filterObject = {
    //             key: this.name,
    //             match: '',
    //             like: '',
    //             from,
    //             to,
    //             in: [],
    //         }

    //         this.handleInput(this.name, filterObject, false)
    //     },
    //     Select(value) {
    //         const filterObject = {
    //             key: this.name,
    //             match: value,
    //             like: '',
    //             from: '',
    //             to: '',
    //             in: [],
    //         }

    //         this.handleInput(this.name, filterObject, false)
    //     }
    // },
    computed: {
        placeholder() {
            let result = '';
            switch (this.type) {
                case 'Select':
                case 'SingleInput':
                    result = _.get(this.options, '0.placeholder');
                    break;
                case 'FromTo':
                case 'DateFromTo':
                case 'NumberFromTo':
                    let options = {}
                    this.options.forEach(option => options[option.key] = option)
                    result = {
                        from: options.from.placeholder,
                        to: options.to.placeholder,
                    };
                    if (options.match) {
                        result.match = options.match.placeholder
                    }
                    break;
            }
            return result;
        },
        isSearchableSelect() {
            return !!(this.options && this.options.length > 10)
                || ['mime', 'type'].includes(this.name)
        },
        matchable() {
            let matchable = false
            if (['FromTo', 'DateFromTo', 'NumberFromTo'].includes(this.type)) {
                const option = this.options.find(option => option.key === 'match')
                matchable = !!option
            }
            return matchable
        },

        // is not reactive :(

        SingleInput: {
            get() {
                const value = _.get(this.values, 'like', '');
                // this.singleInputValue = value
                return value;
            },
            set(value) {
                this.singleInputValue = value;

                const filterObject = {
                    key: this.name,
                    match: '',
                    like: value,
                    from: '',
                    to: '',
                    in: []
                };

                this.$emit('change', this.name, filterObject, !_.isEmpty(value));
                // this.handleInput(this.name, filterObject, ! _.isEmpty(value))
            }
        },
        From: {
            get() {
                return _.get(this.values, 'from', '');
            },
            set(value) {
                let to = this.To;
                let from = value;

                if (this.type === 'NumberFromTo' && from && to) {
                    from = parseFloat(from);
                    to = parseFloat(to);

                    // if (from > to) {
                    //     [from, to] = [to, from] // swap the values
                    //     return // for the time beeing; return without filtering while not valid
                    // }
                }

                this.fromValue = from;

                const filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from,
                    to,
                    in: []
                };

                this.$emit('change', this.name, filterObject, !_.isEmpty(value));
                // this.handleInput(this.name, filterObject, ! _.isEmpty(value))
            }
        },
        To: {
            get() {
                return _.get(this.values, 'to', '');
            },
            set(value) {
                let from = this.From;
                let to = value;

                if (this.type === 'NumberFromTo' && from && to) {
                    from = parseFloat(from);
                    to = parseFloat(to);

                    // if (from > to) {
                    //     [from, to] = [to, from] // swap the values
                    //     return // for the time beeing; return without filtering while not valid
                    // }
                }

                this.toValue = to;

                const filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from,
                    to,
                    in: []
                };

                this.$emit('change', this.name, filterObject, !_.isEmpty(value));
                // this.handleInput(this.name, filterObject, ! _.isEmpty(value))
            }
        },
        DateRange: {
            get() {
                const from = _.get(this.values, 'from', false);
                const start = from ? new Date(from * 1000) : '';

                const to = _.get(this.values, 'to', false);
                const end = to ? new Date(to * 1000) : '';

                return [start, end];
                // return [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)];
            },
            set(value) {
                const start = _.get(value, 0, false);
                const from = start ? Math.round(start.getTime() / 1000) : '';

                const end = _.get(value, 1, false);
                const to = end ? Math.round(end.getTime() / 1000) : '';

                if (start) this.fromValue = format(start, this.$t('yyyy-MM-dd'));
                if (end) this.toValue = format(end, this.$t('yyyy-MM-dd'));

                const filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from,
                    to,
                    in: []
                };

                this.$emit('change', this.name, filterObject, false);
                // this.handleInput(this.name, filterObject, false)
            }
        },
        Select: {
            get() {
                return _.get(this.values, 'match', '');
            },
            set(value) {
                const filterObject = {
                    key: this.name,
                    match: value,
                    like: '',
                    from: '',
                    to: '',
                    in: []
                };

                this.$emit('change', this.name, filterObject, false);
                // this.handleInput(this.name, filterObject, false)
            }
        },
        activeOption() {
            let activeOption = '';
            if (this.type === 'Select') {
                const value = _.get(this.values, 'match', '');
                activeOption = _.find(this.options, option => value == option.value || value == option.key);
            }

            return activeOption;
        },
        multiSelect: {
            get() {
                return _.get(this.values, 'in') || [];
            },
            set(value) {
                const filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from: '',
                    to: '',
                    in: value
                };

                this.$emit('change', this.name, filterObject, false);
                // this.handleInput(this.name, filterObject, false)
            }
        },
        activeOptions() {
            let activeOptions = [];
            if (this.type === 'MultiSelect') {
                const values = _.get(this.values, 'in') || [];
                values.forEach(value => {
                    const option = this.options.find(option => option.value === value || option.key === value);
                    if (option) activeOptions.push(option);
                });
            }

            return activeOptions;
        },
        treeOptions() {
            if (this.type !== 'TreeMultiSelect' || !this.options) return [];
            const flat = this.options.map(option => ({
                id: option.value,
                name: option.label,
                label: option.label,
                _lft: option._lft,
                _rgt: option._rgt,
                depth: option.depth,
            }));
            return NestedSet.createTree(_.cloneDeep(flat));
        },
        treeMultiSelect: {
            get() {
                return _.get(this.values, 'in') || [];
            },
            set(value) {
                const ids = (value || []).map(Number);
                const filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from: '',
                    to: '',
                    in: ids,
                };
                this.$emit('change', this.name, filterObject, ids.length === 0);
            },
        },
        activeTreeOptions() {
            if (this.type !== 'TreeMultiSelect') return [];
            const values = _.get(this.values, 'in') || [];
            return (this.options || []).filter(option => values.includes(option.value) || values.includes(Number(option.value)));
        },
    },
    methods: {
        getTreeBreadcrumb(option) {
            const flat = (this.options || []).map(opt => ({
                id: opt.value,
                name: opt.label,
                _lft: opt._lft,
                _rgt: opt._rgt,
                depth: opt.depth,
            }));
            const node = { id: option.value || option.id, _lft: option._lft, _rgt: option._rgt };
            const ancestors = NestedSet.getAncestors(flat, node);
            if (ancestors && ancestors.length) {
                return [...ancestors.map(ancestor => ancestor.name), option.label || option.name].join(' > ');
            }
            return option.label || option.name;
        },
        handleMatchCheckbox() {
            this.match = !this.match
            let filterObject = {}
            if (!this.match) {
                filterObject = {
                    key: this.name,
                    match: '',
                    like: '',
                    from: this.values.like,
                    to: this.values.to,
                    in: []
                };

                if (this.values.like) this.$emit('change', this.name, filterObject, false);
            } else {
                filterObject = {
                    key: this.name,
                    match: '',
                    like: this.values.from,
                    from: '',
                    to: this.values.to,
                    in: []
                };

                if (this.values.from) this.$emit('change', this.name, filterObject, false);
            }
        }
    },
    mounted() {
        if (this.matchable && !this.values.from) {
            const option = this.options.find(option => option.key === 'match')
            const others = this.options.filter(el => el.position > option.position)
            if (others.length === 2) this.match = true
        }
    }
};
</script>

<style lang="sass" scoped>
.from
    margin-bottom: 5px
.filter
    position: relative
    .input
        position: absolute
        top: 0
        left: 0
        width: 100%
.occupy-space
    min-height: 28px
    opacity: 0
    nobr
        padding-left: 11px
        font-size: 12px
        font-weight: normal
    &.single-input nobr,
    &.from-to nobr,
    &.select nobr
        padding-right: 30px
    &.number-from-to nobr
        padding-right: 50px
    &.multi-select
        height: auto
        min-height: 28px
        padding: 3px
        padding-right: 31px
        & > div
            margin: 2px 4px
            height: 20px
            display: inline-block
            & > nobr
                padding-right: 20px
                padding-left: 5px
    &.date-from-to nobr
        padding-left: 35px
        padding-right: 40px
    &.from-to,
    &.number-from-to,
    &.date-from-to
        height: 51px

.occupy-select-input-space
    height: 28px
    width: 120px

.single-input
    :deep()
        .el-input__clear
            font-size: 15px
        .el-input__suffix-inner
            position: relative

.el-select
    width: 100%

.to-flex
    display: flex
    align-items: center
    gap: 4px

.matchable
    min-width: 100px
    .el-checkbox:deep() .el-checkbox__label
        padding-left: 0.5rem
        color: $color-grey-text

.filter .input
    :deep()
        .vue-treeselect__control
            display: flex
            align-items: center
            height: auto
            min-height: 28px
            font-size: 12px
            padding-right: 10px
            border-radius: 14px
        .vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__control
            border-bottom-left-radius: 0
            border-bottom-right-radius: 0
        .vue-treeselect--open.vue-treeselect--open-below .vue-treeselect__menu
            border-bottom-left-radius: 14px
            border-bottom-right-radius: 14px
        .vue-treeselect .vue-treeselect__placeholder,
        .vue-treeselect .vue-treeselect__single-value
            line-height: 26px
            font-size: 12px
        .vue-treeselect__value-container
            flex: 1 1 auto
            min-width: 0
            padding: 0 26px 0 4px
            line-height: 1
        .vue-treeselect__x-container
            display: flex
            align-items: center
            justify-content: center
            flex: 0 0 20px
        .vue-treeselect__control-arrow-container
            display: flex
            align-items: center
            justify-content: center
            flex: 0 0 20px
        .vue-treeselect__multi-value
            margin-bottom: 0
        .vue-treeselect__multi-value-item-container
            padding-top: 3px
            padding-bottom: 3px
        .vue-treeselect__multi-value-item
            height: 20px
            line-height: 20px
            font-size: 12px
        .vue-treeselect__input-container
            padding: 0
        .vue-treeselect__input
            height: 20px
            font-size: 12px
            padding: 0

</style>
